import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as DataPipelineListRoute } from '~/core/routes/data-pipeline/_index';
import { Route as DataPipelineDetailsRoute } from '~/core/routes/data-pipeline/details/[meshId]/_index';

// Exports
export const permissions: PermissionsFn = (context) => {
  if (
    context.user.organization.slug === 'valleyBank' &&
    context.user.roleType !== 'ADMIN'
  ) {
    // for valley bank data pipeline is available only to admins.
    return 'deny';
  }
  return context.flags.productsDataPipelinePermissions;
};
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /data-pipeline/*
  children: [
    { index: true, element: <DataPipelineListRoute /> },
    { path: 'details/:meshId', element: <DataPipelineDetailsRoute /> },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
